import { useEffect, useState } from 'react';
import { Icon } from '../../../../layout/Icon.jsx';

const REQUIRED_PHRASE = 'استعادة كاملة';

export function ConfirmRestoreModal({ open, fileName, onClose, onConfirm, loading }) {
  const [text, setText] = useState('');

  useEffect(() => {
    if (!open) setText('');
  }, [open]);

  if (!open) return null;
  const armed = text.trim() === REQUIRED_PHRASE;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 grid place-items-center p-4">
      <div className="bg-white rounded-[14px] shadow-pop w-full max-w-[480px] overflow-hidden border-2 border-[#0284C7]">
        <div className="px-5 py-4 border-b border-line flex items-center justify-between bg-[#0284C7] text-white">
          <h3 className="font-extrabold text-[15px] m-0">💾 استعادة نسخة احتياطية — استبدال كامل</h3>
          <button type="button" onClick={onClose} disabled={loading} className="text-white/80 hover:text-white">
            <Icon name="x" size={18} />
          </button>
        </div>

        <div className="p-5">
          <p className="text-[13px] text-ink leading-relaxed mb-2 font-semibold">
            سيتم استبدال <b>كل البيانات الحالية</b> بمحتوى الملف:
          </p>
          <div className="text-[12.5px] font-mono bg-paper-2 border border-line rounded-[8px] px-3 py-2 mb-3 break-all" dir="ltr">
            {fileName}
          </div>
          <p className="text-[12.5px] text-ink-2 leading-relaxed mb-2">
            كل الجداول (الأطفال، الجلسات، الفواتير، المستخدمون…) والصور المرفوعة ستُستبدل
            بما في النسخة. يُحفظ <b>سناب أمان تلقائي</b> على الخادم قبل البدء.
          </p>
          <div className="text-[11.5px] text-cyan-800 bg-cyan-50 border border-cyan-200 rounded-[8px] px-3 py-2 mb-4">
            🔑 أغلِق النظام على بقية الأجهزة قبل الاستعادة، وستُسجَّل خروجك أنت تلقائياً بعدها —
            ادخل بحسابات النسخة المستعادة.
          </div>

          <label className="block text-[12.5px] font-semibold mb-1.5">
            للتأكيد، اكتب <span className="font-mono bg-cyan-100 text-cyan-800 px-1.5 py-0.5 rounded">{REQUIRED_PHRASE}</span> في المربع أدناه:
          </label>
          <input
            type="text"
            className="input text-[14px] font-mono"
            placeholder={REQUIRED_PHRASE}
            value={text}
            onChange={(e) => setText(e.target.value)}
            disabled={loading}
            autoFocus
          />
        </div>

        <div className="px-5 py-3 border-t border-line flex items-center justify-end gap-2 bg-paper-2">
          <button type="button" className="btn" onClick={onClose} disabled={loading}>
            إلغاء
          </button>
          <button
            type="button"
            className="btn text-white"
            style={{ background: '#0284C7' }}
            onClick={onConfirm}
            disabled={!armed || loading}
          >
            {loading ? 'جاري الاستعادة…' : 'تأكيد الاستعادة'}
          </button>
        </div>
      </div>
    </div>
  );
}
